import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '@src/environments/environment';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { PersonOrganization } from '@src/app/models/personorganization';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  },
)
}

@Injectable({
  providedIn: 'root'
})
export class PersonmodalService {
  personUrl:string = environment.apiUrl+'/person/';
  constructor(private http:HttpClient) { }

  getPerson(personId:string,orgId:string) {
    var urlCombo = this.personUrl+personId+'/organization/'+SessionHelper.getChoosenOrg();
    return this.http.get<PersonOrganization>(urlCombo,httpOptions);
  }
  savePersonOrg(personDetail:PersonOrganization){
    var urlCombo = this.personUrl+personDetail.personId+'/organization/'+SessionHelper.getChoosenOrg();
    return this.http.patch<PersonOrganization>(urlCombo,personDetail,httpOptions);
  }
  kickMember(personDetail:PersonOrganization){
    var urlCombo = this.personUrl+personDetail.personId+'/organization/'+SessionHelper.getChoosenOrg()+'/leave';
    return this.http.patch<PersonOrganization>(urlCombo,personDetail,httpOptions);
  }
}
